<template>
  <div class="container">
    <!-- 修改手机弹窗 -->
    <modify-phone
      v-if="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      :doctor_id="doctor_id"
      :phone="detail.phone"
      @getDetail="getDetail"
    ></modify-phone>
    <div class="leftbox">
      <div class="item">
        <span>
          <span class="gray">医生姓名：</span>
          <span class="black">{{ detail.doctor_name }}</span>
        </span>
        <span style="margin: 0 10px">
          <span class="gray">性别：</span>
          <span class="black" v-if="detail.sex == 1">男</span>
          <span class="black" v-if="detail.sex == 2">女</span>
        </span>
        <span>
          <span class="gray">手机号：</span>
          <span class="black">{{ detail.phone }}</span>
          <el-link
            @click="editPhone"
            type="primary"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1531') : false
            "
            style="padding: 0 0 4px 4px"
            >修改</el-link
          >
        </span>
        <span style="margin-left: 30px">
          <span class="gray">认证时间：</span>
          <span class="black">{{ detail.update_time }}</span>
        </span>
      </div>
      <div class="item">
        <span>
          <span class="gray">身份证号：</span>
          <span class="black">{{ detail.id_card }}</span>
        </span>
        <span style="margin: 0 70px">
          <span class="gray">出生日期：</span>
          <span class="black">{{ detail.birthday }}</span>
        </span>
        <span>
          <span class="gray">年龄：</span>
          <span class="black">{{ detail.age }}</span>
        </span>
      </div>
      <!-- <div class="item">
        <span>
          <span class="gray" style="width: 186px"
            >颗粒剂国标用量转换授权：</span
          >
          <span class="black">{{
            detail.empower == 1 ? "已授权" : "未授权"
          }}</span>
        </span>
      </div> -->
      <div class="item">
        <span>
          <span class="gray">实名认证：</span>
          <span class="black">{{
            detail.real_name_auth == 1 ? "是" : "否"
          }}</span>
        </span>
      </div>
      <!-- <div class="item">
        <span>
          <span class="gray">承诺书：</span>
          <span class="black">{{
            detail.is_commitment == 1 ? "已确认" : "未确认"
          }}</span>
        </span>
      </div> -->
      <div class="item">
        <span class="gray">所在地区：</span>
        <span class="black"
          >{{ detail.province_name }}{{ detail.city_name
          }}{{ detail.district_name }}</span
        >
      </div>
      <div class="item">
        <span class="gray">医院名称：</span>
        <span class="black">{{ detail.hospital }}</span>
      </div>

      <div class="item" style="display: flex">
        <span class="gray">擅长方向：</span>
        <div class="black" style="width: 700px">{{ goodat }}</div>
      </div>

      <div class="item" style="display: flex">
        <span class="gray">专业：</span>
        <div class="black" style="width: 700px">{{ detail.major_name }}</div>
      </div>

      <div class="item" style="display: flex">
        <span class="gray">执业证书编号：</span>
        <div class="black" style="width: 700px">
          {{ detail.qualification_num }}
        </div>
      </div>

      <div class="item">
        <span class="gray">科室：</span>
        <span class="black">{{ detail.department_name }}</span>
      </div>
      <div class="item">
        <span class="gray">职称：</span>
        <span class="black">{{ detail.title }}</span>
      </div>
      <div class="item" style="display: flex">
        <span class="gray">个人简介：</span>
        <div class="black" style="width: 700px">{{ detail.introduction }}</div>
      </div>

      <div
        class="item"
        style="display: flex; align-items: center; margin: 30px 0"
      >
        <span class="gray">医生头像：</span>
        <span class="black">
          <el-image
            style="width: 80px; height: 80px"
            :src="detail.head_img"
            :preview-src-list="[detail.head_img]"
          ></el-image>
        </span>
      </div>
      <div class="imgbox">
        <div>
          <div style="color: #747981; margin-bottom: 8px">医师执业证书：</div>
          <div>
            <el-image
              class="img"
              :src="zhiye_img1"
              :preview-src-list="imgList"
            ></el-image>
            <el-image
              class="img"
              :src="zhiye_img2"
              :preview-src-list="imgList"
              style="margin-left: 10px"
            ></el-image>
          </div>
        </div>

        <div style="margin: 0 20px">
          <div style="color: #747981; margin-bottom: 8px">医生职称证书：</div>
          <div>
            <el-image class="img" :src="zige_img1" :preview-src-list="imgList">
              <div slot="error" class="image-slot-renzheng">
                <span v-if="zige_img1 == ''">未上传</span>
                <span v-else>加载失败</span>
              </div>
            </el-image>
            <el-image
              class="img"
              :src="zige_img2"
              :preview-src-list="imgList"
              style="margin-left: 10px"
            >
              <div slot="error" class="image-slot-renzheng">
                <span v-if="zige_img2 == ''">未上传</span>
                <span v-else>加载失败</span>
              </div>
            </el-image>
          </div>
        </div>

        <div>
          <div style="color: #747981; margin-bottom: 8px">
            专业技术资格证书：
          </div>
          <div>
            <el-image
              class="img"
              :src="qualification_certificate"
              :preview-src-list="imgList"
            >
              <div slot="error" class="image-slot-renzheng">
                <span v-if="qualification_certificate == ''">未上传</span>
                <span v-else>加载失败</span>
              </div>
            </el-image>
          </div>
        </div>
      </div>
    </div>
    <div class="rightbox">
      <div>
        <div>
          <img :src="detail.qr_code" alt style="width: 150px" />
          <div
            style="margin-bottom: 10px"
            v-if="detail.recommender_info.recommender_name"
          >
            <span>推荐人：</span>
            <span style="margin: 0 10px">{{
              detail.recommender_info.recommender_name
            }}</span>
            <span>{{ detail.recommender_info.phone }}</span>
          </div>
          <div
            v-if="detail.recommender_doctor_info.doctor_name"
            style="margin: 10px 0"
          >
            <span>邀请医生：</span>
            <span style="cursor: pointer; color: #ed4848" @click="toDetail">{{
              detail.recommender_doctor_info.doctor_name
            }}</span>
          </div>
        </div>
        <div>
          <el-button
            type="primary"
            style="width: 140px"
            @click="showDialog"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('804') : false
            "
            >诊后管理费上限</el-button
          >
        </div>
        <div style="margin: 10px 0">
          <el-button
            style="width: 140px"
            type="primary"
            @click="doctorinfo = true"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('413') : false
            "
            >修改信息</el-button
          >
        </div>
        <div style="margin: 10px 0">
          <el-button
            style="width: 140px"
            type="primary"
            @click="getLogList"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('414') : false
            "
            >修改记录</el-button
          >
        </div>

        <div>
          <el-button
            style="width: 140px"
            type="primary"
            @click="getRecommenderLog"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1657') : false
            "
            >绑定记录</el-button
          >
        </div>
      </div>
    </div>
    <!-- 修改医生提成 -->
    <el-dialog
      title="修改诊后管理费上限"
      :visible.sync="dialog"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-dialog
        width="300px"
        title="批量修改上限"
        :visible.sync="innerdialog"
        append-to-body
        :close-on-click-modal="false"
      >
        <div style="padding: 20px">
          <div style="margin-bottom: 10px">请输入</div>
          <el-input-number
            v-model="proportion"
            :min="0"
            :max="1"
            :precision="2"
            :controls="false"
            label="请输入"
          ></el-input-number>
          <el-button
            type="primary"
            size="medium"
            @click="submitAll"
            style="margin-left: 10px"
            >保存</el-button
          >
        </div>
      </el-dialog>
      <div style="padding: 24px">
        <div style="margin-bottom: 10px;font-size: 16px">
          <div>医生：{{ detail.doctor_name }}</div>
          <div style="margin-bottom: 10px;">
            医生默认值:(说明:诊后管理费上限取值优先级
            药房剂型设置值>医生默认值>药房默认值)
          </div>
          <div style="margin-bottom: 10px;">
            <span style="margin-right: 10px">颗粒处方诊后管理费上限</span>
            <el-input-number
              v-model="proportion1"
              :min="0"
              :max="99"
              :controls="false"
              label="请输入"
              size="small"
            ></el-input-number>
            <span>&nbsp;%&nbsp;</span>
            <el-button
              type="primary"
              size="small"
              @click="setDoctorProportionBtn(1)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('2033') : false
              "
              >保存</el-button
            >
          </div>
          <div>
            <span style="margin-right: 10px">饮片处方诊后管理费上限</span>
            <el-input-number
              v-model="proportion2"
              :min="0"
              :max="99"
              :controls="false"
              label="请输入"
              size="small"
            ></el-input-number>
            <span>&nbsp;%&nbsp;</span>
            <el-button
              type="primary"
              size="small"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('2033') : false
              "
              @click="setDoctorProportionBtn(2)"
              >保存</el-button
            >
          </div>
        </div>
        <div style="margin-bottom: 20px; font-size: 16px" class="flex_between">
          <div>
            <span style="margin-right: 10px">药房剂型设置：</span>
            <myInputSerch
              v-model="hospital_name"
              @update="searchHospital"
            ></myInputSerch>
          </div>
          <el-button type="primary" size="medium" @click="submitAllbtn"
            >批量保存</el-button
          >
        </div>
        <div class="dialogtable">
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange"
            class="basicMsgDia"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
              prop="hospital_name"
              label="药房"
            ></el-table-column>
            <el-table-column prop="drug_type_name" label="剂型名称" width="110">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.drug_type != 0 && scope.row.drug_type != -1"
                  >{{ scope.row.drug_type_name }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="hospital_name"
              label="剂型分类/药品类型"
              width="150"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.drug_type == 0">养生方</span>
                <span v-if="scope.row.drug_type == -1">成药</span>
                <span v-if="scope.row.drug_type_pid == 1">颗粒</span>
                <span v-if="scope.row.drug_type_pid == 2">饮片</span>
                <span v-if="scope.row.drug_type_pid == 3">膏方</span>
                <span v-if="scope.row.drug_type_pid == 4">丸剂</span>
              </template>
            </el-table-column>
            <el-table-column label="诊后管理费上限" width="160">
              <template slot-scope="scope">
                <span v-if="scope.row.edit">
                  <el-input-number
                    v-model="scope.row.edit_proportion"
                    :min="0"
                    :max="9999"
                    :precision="2"
                    :controls="false"
                    label="请输入"
                    style="width: 100px; margin-right: 5px"
                  ></el-input-number>
                  <el-button
                    type="text"
                    @click="
                      scope.row.edit = false;
                      scope.row.edit_proportion = '';
                    "
                    >取消</el-button
                  >
                </span>
                <span v-else>
                  <span v-if="scope.row.proportion">{{
                    scope.row.proportion
                  }}</span>
                  <span v-else>{{
                    scope.row.default_proportion
                      ? scope.row.default_proportion + "(默认值)"
                      : ""
                  }}</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="70">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="submit([scope.row])"
                  v-if="scope.row.edit"
                  >保存</el-button
                >
                <el-button type="text" @click="scope.row.edit = true" v-else
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <!-- 修改医生信息 -->
    <EditInfo
      v-if="doctorinfo"
      @close="doctorinfo = false"
      @editInfo="editInfo"
    ></EditInfo>
    <!-- 修改记录 -->
    <el-dialog
      title="修改记录"
      :visible.sync="editlist"
      width="700px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px">
        <el-table :data="logList" border style="width: 100%">
          <el-table-column
            prop="create_time"
            label="修改时间"
            width="140"
          ></el-table-column>
          <el-table-column prop="content" label="修改内容">
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.content" :key="index">
                {{ item }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="admin_name"
            label="修改人"
            width="140"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 绑定记录 -->
    <el-dialog
      title="绑定记录"
      :visible.sync="recommenderVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px">
        <el-table :data="recommenderList" border style="width: 100%">
          <el-table-column prop="create_time" label="操作时间" width="140">
            <template slot-scope="scope">
              {{ scope.row.create_time | dateFormat }}
            </template>
          </el-table-column>

          <el-table-column prop="content" label="类型">
            <template slot-scope="scope">
              {{ scope.row.type == 1 ? "绑定" : "解绑" }}
            </template>
          </el-table-column>

          <el-table-column
            prop="recommender_name"
            label="推荐人"
            width="140"
          ></el-table-column>

          <el-table-column
            prop="admin_name"
            label="操作人"
            width="140"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import myInputSerch from "@/components/myInputSerch";
import modifyPhone from "@/components/modifyPhone";
import doctor from "../../../api/doctor";
import platform from "../../../api/platform";
import EditInfo from "./EditInfo";
import dayjs from "dayjs";
import _ from "lodash";
export default {
  data() {
    return {
      proportion1: undefined,
      proportion2: undefined,
      doctor_id: this.$route.query.doctor_id,
      detail: { recommender_info: {}, recommender_doctor_info: {} },
      goodat: "",
      qualification_certificate: "",
      zhiye_img1: "",
      zhiye_img2: "",
      zige_img1: "",
      zige_img2: "",
      imgList: [],
      dialog: false,
      tableData: [],
      selection: [],
      innerdialog: false,
      proportion: 0,
      logList: [],
      doctorinfo: false,
      editlist: false,
      hospital_name: "",
      dialogVisible: false,
      recommenderVisible: false,
      recommenderList: [],
    };
  },
  components: {
    EditInfo,
    myInputSerch,
    modifyPhone,
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取详情
    getDetail() {
      let doctor_id = this.$route.query.doctor_id;
      doctor.doctorDetail({ doctor_id }).then((res) => {
        if (res.code == 0) {
          this.detail = res.data.info;
          this.detail.update_time = platform.timestampToTime(
            this.detail.update_time
          );
          let info = res.data.info;
          let goodatarr = this.detail.be_good_at.map((item) => {
            return item.be_good_at_name;
          });
          this.goodat = goodatarr.toString();
          // this.goodat = this.detail.be_good_at_name;
          if (info.qualification_certificate.path) {
            this.requestImg(
              info.qualification_certificate.path,
              "qualification_certificate"
            );
          }
          if (info.practice_certificate.length) {
            this.requestImg(info.practice_certificate[0].path, "zhiye_img1");
            this.requestImg(info.practice_certificate[1].path, "zhiye_img2");
          }
          if (info.qualification.length) {
            this.requestImg(info.qualification[0].path, "zige_img1");
            this.requestImg(info.qualification[1].path, "zige_img2");
          }
        }
      });
    },
    requestImg(src, imgname) {
      let value = this.getUrlParam("resources_id", src);
      this.axios
        .get("doctor/cms/getImg", {
          params: { resources_id: value },
        })
        .then((res) => {
          this[imgname] = res;
          this.imgList.push(res);
        });
    },
    getUrlParam(key, url) {
      var reg = new RegExp("(^|\\?|&)" + key + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(url)) return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    },
    //获取修改记录
    getLogList() {
      let doctor_id = this.$route.query.doctor_id;
      this.axios
        .post("platform/doctor/getDoctorAuthenticationLogList", { doctor_id })
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length) {
              this.$message.warning("暂时没有修改记录");
            } else {
              this.logList = res.data.list.map((item) => {
                item.create_time = dayjs
                  .unix(item.create_time)
                  .format("YYYY-MM-DD HH:mm");
                item.content = item.content.split("||");
                return item;
              });
              this.editlist = true;
            }
          }
        });
    },
    //修改医生详情弹窗
    editInfo() {
      this.doctorinfo = false;
      this.getDetail();
    },
    //推荐医生详情
    toDetail() {
      let doctor_id = this.detail.recommender_doctor_info.doctor_id;
      let routeData = this.$router.resolve({
        path: "doctordetail",
        query: {
          doctor_id: doctor_id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    //医生提成设置弹窗
    showDialog() {
      let data = {
        doctor_id: this.detail.doctor_id,
        hospital_name: this.hospital_name,
        page: 1,
        pageNumber: 100,
      };
      this.axios
        .post("platform/doctor/getHospitalDoctorList", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.edit = false;
              item.edit_proportion = "";
              return item;
            });
            let proportion1 = res.data.proportion[0].proportion;
            let proportion2 = res.data.proportion[1].proportion;
            this.proportion1 = proportion1 == "" ? undefined : proportion1;
            this.proportion2 = proportion2 == "" ? undefined : proportion2;
            this.dialog = true;
          }
        });
    },
    searchHospital() {
      let data = {
        doctor_id: this.detail.doctor_id,
        hospital_name: this.hospital_name,
        page: 1,
        pageNumber: 100,
      };
      this.axios
        .post("platform/doctor/getHospitalDoctorList", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.edit = false;
              item.edit_proportion = "";
              return item;
            });
          }
        });
    },
    //多选
    handleSelectionChange(val) {
      this.selection = val;
    },
    //多选
    submitAllbtn() {
      if (!this.selection.length) {
        this.$message.error("请选择需要修改的数据");
        return false;
      }
      this.innerdialog = true;
    },
    submitAll() {
      let proportion = 0;
      if (this.proportion) {
        proportion = this.proportion;
      }
      let hospital_drug = [];
      hospital_drug = this.selection.map((item) => {
        item = _.pick(item, ["hospital_id", "drug_type", "proportion"]);
        item.proportion = proportion;
        return item;
      });
      let data = {
        doctor_id: this.detail.doctor_id,
        hospital_drug,
      };
      this.axios
        .post("platform/doctor/setDoctorProportionNew", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
            if (this.innerdialog) {
              this.innerdialog = false;
            }
            this.showDialog();
          }
        });
    },
    //提交医生提成设置
    submit(row) {
      let hospital_drug = [];
      hospital_drug = row.map((item) => {
        item.proportion = item.edit_proportion;
        item = _.pick(item, ["hospital_id", "drug_type", "proportion"]);
        return item;
      });
      let data = {
        doctor_id: this.detail.doctor_id,
        hospital_drug,
      };
      this.axios
        .post("platform/doctor/setDoctorProportionNew", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
            if (this.innerdialog) {
              this.innerdialog = false;
            }
            this.showDialog();
          }
        });
    },
    // 修改手机号
    editPhone() {
      this.dialogVisible = true;
    },
    // 绑定记录
    getRecommenderLog() {
      let params = {
        doctor_id: this.$route.query.doctor_id,
      };
      let loading = this.$loading();

      doctor
        .getRecommenderLog(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            if (!data.list.length) {
              this.recommenderList = [];
              this.$message.warning("暂无绑定记录");
            } else {
              this.recommenderVisible = true;
              this.recommenderList = data.list;
            }
          }
          loading.close();
        })
        .catch(() => loading.close());
    },
    // 医生和剂型之间的药品抽成
    setDoctorProportionBtn(drug_type) {
      let proportionVal = drug_type == 1 ? this.proportion1 : this.proportion2;
      let proportion = proportionVal === undefined ? "" : proportionVal;

      let params = {
        doctor_id: this.doctor_id,
        drug_type,
        proportion,
      };
      this.axios
        .post("platform/doctor/setDoctorProportionDurg", { list: [params] })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
          }
        });
    },
  },
  created() {
    this.getDetail();
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 24px 24px 0 24px;
  box-sizing: border-box;
  background-color: #ffffff;
  text-align: left;
  display: flex;
}
.leftbox {
  flex: 1;
  box-sizing: border-box;
  // min-height: calc(100vh - 210px);
  text-align: left;
}
.rightbox {
  width: 260px;
  box-sizing: border-box;
  font-size: 15px;
  text-align: center;
}
.gray {
  color: #747981;
  display: inline-block;
  width: 100px;
  text-align: right;
}
.black {
  color: #333333;
}
.item {
  margin-bottom: 20px;
}
.imgbox {
  display: flex;
  .img {
    width: 180px;
    height: 125px;
    cursor: pointer;
  }
}
.dialogtable {
  height: calc(100vh - 400px);
  overflow-y: scroll;
}
</style>
<style>
.basicMsgDia .el-table__header-wrapper .el-checkbox {
  display: none;
}
.image-slot-renzheng {
  height: 100%;
  font-size: 14px;
  color: #c0c4cc;
  background-color: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
